import React from "react";
import "./CommentsHistory.css";
import ModalWrap from "../../../Components/ModalWrap/ModalWrap";
import CustomTable from "../../../Components/CustomTable/CustomTable";
import CloseIcon from "../../../../assets/images/admin-dashboard/modal-close.svg";
const data = [
  {
    employee: "chandu@serenetax.com",
    message: "Testing....",
    date: "Apr 4, 2023",
  },
  {
    employee: "tarak@serenetax.com",
    message: "hello, This is ragab",
    date: "Dec 4, 2023",
  },
];

const CommentsHistory = ({ open, handleClose }) => {
  const columns = [
    { key: "employee", title: "Employee" },
    { key: "message", title: "Message" },
    { key: "date", title: "Date" },
  ];
  return (
    <ModalWrap open={open} handleClose={handleClose}>
      <div className="commentshistory__modal_wrap">
        <div className="commentshistory__modal_header">
          <div className="commentshistory__modal_hdrleft">Comments History</div>
          <div className="commentshistory__modal_hdrright">
            <div
              className="commentshistory__modal_closebtn"
              onClick={handleClose}
            >
              <img
                src={CloseIcon}
                alt=""
                className="commentshistory__modal_closebtnicn"
              />
            </div>
          </div>
        </div>
        <CustomTable
          columns={columns}
          data={data}
          onRowClick={() => {}}
          itemsPerPage={5}
        />
      </div>
    </ModalWrap>
  );
};

export default CommentsHistory;
